import store from '@this/store';
import AuthPopup from '@blocks/auth/AuthPopup';

import { isPC, isAlipay } from '@/utils/browser';

export function getAuthJumpURL(callback) {
  const url = `${window.location.origin}${process.env.VUE_APP_H5_BASE}/auth/alipay/jump`;
  const search = `?callback=${encodeURIComponent(callback)}`;
  const jumpURL = `${url}${search}`;
  return jumpURL;
}

export function handleAuth({ href }) {
  return new Promise((resolve, reject) => {
    if (store.state.user.uid) {
      return resolve({});
    }
    // 判断pc端
    if (isPC) {
      AuthPopup(window.parent.location.href);
      return reject({});
    }
    if (href) {
      const callback = window.parent.location.href;
      const jumpURL = getAuthJumpURL(callback);
      window.parent.location.href = jumpURL;
    } else {
      // 监听回来
      if (isAlipay) {
        const handleResume = () => {
          ap.offResume(handleResume);
          // 授权成功后操作
          const res = JSON.parse(localStorage.getItem('authSuccess')) || {};
          localStorage.removeItem('authSuccess');
          if (res.success === true) {
            store
              .dispatch('user/authSuccess')
              .then(() => {
                resolve({});
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            reject({});
          }
        };
        ap.onResume(handleResume);
      }
      // 跳转
      if (isAlipay) {
        const callback = `${window.location.origin}/dist/_static/close.html`;
        const jumpURL = getAuthJumpURL(callback);
        ap.pushWindow(jumpURL);
      } else {
        const callback = window.parent.location.href;
        const jumpURL = getAuthJumpURL(callback);
        window.parent.location.href = jumpURL;
      }
    }
  });
}
